export default __webpack_public_path__ + "static/media/p1.914326c6.png";